/* src/app/merchants/merchant-settlement/merchant-settlement.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=merchant-settlement.component.css.map */
